import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenLogisticsNetworkPageBreadcrumbs } from '@/pages/Business/config';
import { NavigateFunction } from 'react-router-dom';

export const childrenDriversPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenLogisticsNetworkPageBreadcrumbs(navigate),
  { label: 'Conductores', onClick: () => navigate('/business/drivers') },
];
